import { Component, ElementRef, ViewChild } from '@angular/core';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { Platform } from '@ionic/angular';
import { HandlerService } from '../handler.service';
import { LocationService } from '../location.service';
import { NativeGeocoderOptions, NativeGeocoder, NativeGeocoderResult } from '@ionic-native/native-geocoder/ngx';
import { LaunchNavigator, LaunchNavigatorOptions } from '@ionic-native/launch-navigator/ngx';
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
declare var google;

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
})
export class MapComponent {
  pop:boolean=false;
  loader:boolean=false;
  newSearch;
  lan;
  lat;
  getData:any=[];
  marker:any;
  id;
  radius;
  radiusInKm;
  locateCheck:boolean=false;
  map: any;
  @ViewChild('map') mapElement: ElementRef;
  url;
  constructor(
    private geolocation: Geolocation,   public handler: HandlerService , private platform: Platform, public location: LocationService,
    private loc: Geolocation,
    private LocationAccuracy: LocationAccuracy,
    public service: ApiService,
    public router: Router,
    private launchNavigator: LaunchNavigator,
    private geoCoder:NativeGeocoder, ) { }

  ngAfterViewInit(){
    this.radius=5000;
    this.radiusInKm=5;
    this.url = window.location.href;
    this.id = this.url.split('/').pop();
    this.service.getAddressById(this.id).subscribe((res:any) => {
      console.log(res)
      this.getData = res;
         })
    this.loadMap();
    // this.getLocation();
    this.askToTurnOnGPS();
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        if (position) {
          console.log("Latitude: " + position.coords.latitude +
            "Longitude: " + position.coords.longitude);
          this.lat = position.coords.latitude;
          this.lan = position.coords.longitude;
          console.log(this.lat);
          console.log(this.lan);
        }
      },
        (error) => console.log(error));
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }

  getAddress(latitude, longitude) {
    return new Promise(function (resolve, reject) {
        var request = new XMLHttpRequest();

        var method = 'GET';
        var url = 'http://maps.googleapis.com/maps/api/geocode/json?latlng=' + latitude + ',' + longitude + '&sensor=true';
        var async = true;

        request.open(method, url, async);
        request.onreadystatechange = function () {
            if (request.readyState == 4) {
                if (request.status == 200) {
                    var data = JSON.parse(request.responseText);
                    var address = data.results[0];
                    console.log(address)
                    resolve(address);
                }
                else {
                    reject(request.status);
                }
            }
        };
        request.send();
    });
}
  
  loadMap(){
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        if (position) {
          console.log(position)
          console.log("Latitude: " + position.coords.latitude +
            "Longitude: " + position.coords.longitude);
          this.lat = position.coords.latitude;
          this.lan = position.coords.longitude;
          this.getAddress(this.lat,this.lan).then(console.log).catch(console.error)
          let pos = new google.maps.LatLng(this.lat, this.lan);
       
          let mapOptions = {
            center: pos,
            zoom: 11,
            mapTypeId: google.maps.MapTypeId.ROADMAP
          }
        console.log(this.radius)
          this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
          this.marker = new google.maps.Marker({
            position: pos,
            animation: google.maps.Animation.DROP,
            map: this.map
          });
          if(this.radius)
          var circle = new google.maps.Circle({
            center: pos,
            map: this.map,
            radius:parseFloat(this.radius) ,          // IN METERS.
            fillColor: '#FF6600',
            fillOpacity: 0.3,
            strokeColor: "#FFF",
            strokeWeight: 0,
            editable: true         // DON'T SHOW CIRCLE BORDER.
        });
        console.log(this.lat)
        
        }
      },
        (error) => console.log(error));
    } else {
      alert("Geolocation is not supported by this browser.");
    }
     


    // }, (err) => {
    //   .log(err);
    // });

  }


    
  loadMap1(){
    this.radius=this.radiusInKm * 1000;
    // if (navigator.geolocation) {
      // navigator.geolocation.getCurrentPosition((position) => {
      //   if (position) {
      //     console.log(position)
      //     console.log("Latitude: " + position.coords.latitude +
      //       "Longitude: " + position.coords.longitude);
          this.lat = this.location.lat;
          this.lan = this.location.lon;
          console.log(this.lat)
          let pos = new google.maps.LatLng(this.lat, this.lan);
       
          let mapOptions = {
            center: pos,
            zoom: 11,
            mapTypeId: google.maps.MapTypeId.ROADMAP
          }
          this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
          this.marker = new google.maps.Marker({
            position: pos,
            animation: google.maps.Animation.DROP,
            map: this.map
          });
          var circle = new google.maps.Circle({
            center: pos,
            map: this.map,
            radius:parseFloat(this.radius) ,         // IN METERS.
            fillColor: '#FF6600',
            fillOpacity: 0.3,
            strokeColor: "#FFF",
            strokeWeight: 0,
            editable: true         // DON'T SHOW CIRCLE BORDER.
        });
    
  }

  addMarker(){

    let marker = new google.maps.Marker({
      map: this.map,
      animation: google.maps.Animation.DROP,
      position: this.map.getCenter()
    });
  
    let content = "<h4>Information!</h4>";          
  
    this.addInfoWindow(marker, content);
  
  }

  addInfoWindow(marker, content){

    let infoWindow = new google.maps.InfoWindow({
      content: content
    });

    google.maps.event.addListener(marker, 'click', () => {
      infoWindow.open(this.map, marker);
    });

  }


  askToTurnOnGPS() {
    this.locateCheck=true;
    this.LocationAccuracy.request(this.LocationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
      () => {  
        this.setLoc()
      },
      error => {
         alert('Device location access is required to fetch your current location')
     this.locateCheck=false;
      }
    
    );
  }

  setLoc(){
    if(this.platform.is('android') || this.platform.is('ios')){
      this.locateCheck=true;
        let options: NativeGeocoderOptions = { useLocale: true,maxResults: 1 };
      this.loc.getCurrentPosition().then(res => {
        this.geoCoder.reverseGeocode(res.coords.latitude, res.coords.longitude, options).then((result: NativeGeocoderResult[]) => {
          this.loader = false;
          this.handler.deny = 0;  
          localStorage.removeItem('deny');
            let x: any = result;
            localStorage.removeItem("place");
            localStorage.setItem('location', JSON.stringify(x));
            let loc;
            loc=JSON.parse(localStorage.getItem('location'));
            this.location.lat=loc[0].latitude;
            this.location.lon=loc[0].longitude;
             this.location.zipcode=loc[0].postalCode;
             this.location.street=loc[0].thoroughfare;
             this.location.stateId=loc[0].administrativeArea;
             if(loc[0].locality){
              this.location.cityId=loc[0].locality; 
             }else{
              this.location.cityId=loc[0].subAdministrativeArea; 
             }
             if(loc[0].subLocality){
              this.location.regionId=loc[0].subLocality;
             }else{
              this.location.regionId=loc[0].neighborhood;
             }
            
            //  if(this.location.regionId=="" || this.location.regionId==null ||this.location.regionId==undefined || !this.location.regionId ){
              // this.getLocationDetails(this.location.cityId); 
            //  }else{
              // this.getLocationDetails(this.location.regionId); 
            //  }
                     
             this.location.pop = false;
             this.locateCheck=false;          },
        err=>{ 
          this.loader = false;
          this.location.pop = false;
          this.locateCheck=false;
          this.handler.err(err);
        })        
    },
    err=>{
      this.handler.deny++;
      if(this.handler.deny > 2 && !localStorage.getItem('deny')){
        this.handler.staticError("Please turn on location access permission for App,from Settings");
        localStorage.setItem("deny" , "1");
      }
      if(localStorage.getItem('deny')){
        this.handler.staticError("Please turn on location access permission for App,from Settings");
      }  
      this.loader = false;
      this.locateCheck=false;
      this.location.pop = false;
    })
 }else{
  
  this.location.pop = false;
  this.loader = false;
  this.locateCheck=false;
 }
 this.location.serviceArea = true;
}



  manualSetLoc(){
    this.location.pop=true;
  }

  onInput() {
    this.location.serviceArea = true;
   this.location.autoComplete(); 
    }

    delete(){
      this.location.lat="";
      this.location.lon="";
       this.location.zipcode="";
       this.location.street="";
       this.location.stateId="";
       this.location.cityId="";
       this.location.regionId="";
    }

    popClose(){
      this.location.pop=false;
    }

    openLocation(){
      this.location.lat="";
      this.location.lon="";
       this.location.zipcode="";
       this.location.street="";
       this.location.stateId="";
       this.location.cityId="";
       this.location.regionId="";
      this.askToTurnOnGPS();  
      
    }

    update(){
      if(this.location.lat || this.location.lon){
      this.loader = true;
        let x;
      var data = {
        houseNbr : this.location.houseNbr,
        street : this.location.street,
         cityId :this.location.cityId,
         regionId : this.location.regionId,
         stateId : this.location.stateId,
         zipcode : this.location.zipcode,
         lat : this.location.lat,
         lon  : this.location.lon,
         serviceRadius:this.radiusInKm,
          type: 1,
          userId: localStorage.getItem('currentUserId'),
          orgId: localStorage.getItem('organizationId'),
      }
  
        Object.assign(this.getData,{lat : this.location.lat,
          lon  : this.location.lon,
          serviceRadius:this.radiusInKm})
        if (this.getData.addresses){
          this.getData.addresses.push(data);    
        }
      
     
      this.service.postProfileDetails(this.id,this.getData).subscribe(res=>{
        this.handler.res('Registration Successfull!!! Verification Pending!!! ')
      this.router.navigate(['/requests'])

    
      this.loader = false;
    },err=>{
      this.handler.err(err)
      this.loader=false;
    }) 
    }
    else{
      this.loader=false;
      this.handler.staticError('Please Enter Your Address!!!S ')
      
    }
  }
 
}
